import { atom } from "recoil";

export const searchTermState = atom({
  key: "searchTermState",
  default: "",
});
